import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { headStyle } from '@/components/ui/Typography/Heading/Head/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineOfferDescription のスタイル
 */
export const hotlineOfferDescriptionStyle = tv({
    slots: {
        base: ['flex flex-col gap-16', 'bg-blue-gray-75', 'rounded-md', 'p-16'],
        content: ['flex flex-col gap-16'],
        item: ['flex flex-col gap-8', 'p-12', 'bg-gray-50', 'rounded-md'],
        itemDescription: [
            textStyle({ color: 'base', size: 'sm' }),
            'whitespace-pre-line',
        ],
        itemTitle: [textStyle({ color: 'base', isBold: true, size: 'sm' })],
        title: [headStyle({ color: 'base', isBold: true, size: 'xxs' })],
    },
    variants: {},
});
